export const ActionKeys = {
	// Atlassian Projects
	CreateProjectProgressUpdate: 'atlassian-project-atlassian-atlassian-project-create-progress-up',
	// Jira
	UpdateWorkItemFields: 'jira-atlassian-work-item-update-single-field',
	UpdateWorkItemAllFieldTypes: 'jira-atlassian-work-item-update-all-field-types-bulk',
	JiraFindIssues: 'jira-find-issues',
	JiraSmartIssueCreateAllField: 'jira-atlassian-work-item-create-all-field-types',
	JiraAdminAgent: 'JiraAdminAgentActionableTool',
	JiraIssueTransition: 'jira-issue-transition-bulk',
	JiraEpicsSuggest: 'jira-epics-suggest',
	JiraIssueDelete: 'jira-issue-delete',
	JiraIssueMove: 'jira-issue-move',
	JiraIssueAssign: 'jira-issue-assign-bulk',
	JiraVersionCreate: 'jira-version-create',
	// Work organizer sprint actions
	JiraCreateSprint: 'jira-atlassian-work-item-create-sprint',
	JiraStartSprint: 'jira-atlassian-board-start-sprint',
	JiraMoveToSprint: 'jira-atlassian-workspace-move-to-sprint-work-item',
	JiraWorkflowEditor: 'jira-workflow-operations',
	// Confluence
	ConfluenceFolderCreate: 'confluence-atlassian-workspace-create-folder',
	ConfluencePageCreate: 'confluence-page-create',
	ConfluencePageComment: 'confluence-page-comment',
	ConfluencePageAddLabel: 'confluence-label-create',
	ConfluencePageRename: 'confluence-page-rename',
	ConfluencePageMove: 'confluence-page-move',
	// JSM
	JsmJourneyBuilder: 'jsm-invoke-orchestrator-agent',
	JsmCreateRequest: 'jsm-create-request',
	JsmCreateRequestV2: 'jsm-create-request-v2',
	CreateRequest: 'create-request',
	JsmCreateEmbeddedRequest: 'help-form-submit',
	JsmCreateSurvey: 'jsm-create-survey',
	JsmLivechat: 'jsm-livechat',
	JsmSolutionComposerPlanSummary: 'jsm-solution-composer-plan-summary',
	// Deep Research
	DeepResearchCreatePageAction: 'deep-research-report-confluence-export',
	// Studio
	StudioTriggerSolutionPlan: 'studio-trigger-solution-plan',
	StudioUpdateAgentDraft: 'studio-atlassian-studio-update-agent-draft',
	StudioWorkspaceUpdateAgentDraft: 'studio-atlassian-workspace-update-draft-agent',
	StudioAutomationTriggerRuleBuild: 'studio-automation-trigger-rule-build',
	StudioAutomationCreateRule: 'automation-platform-atlassian-automation-create-rule',
	UpdateAgentConfigurationTool: 'UpdateAgentConfigurationTool',
	StudioCreateAgent: 'CreateAgentTool',
	StudioLandingPageRedirect: 'studio-landing-page-redirect',
	// Plans
	JiraPlansUpdateWorkSource: 'jira-atlassian-plan-update-work-sources',
	JiraPlansCreateProgramBoard: 'jira-plan-add-program-board-plugin',
	JiraPlansDeleteProgramBoard: 'Jira-Plan-Delete-Program-Board-Plugin',
	JiraPlansCreateWorkItem: 'jira-atlassian-plan-create-work-item',
	JiraPlansCreateRelease: 'Jira-Plan-Create-Release-Plugin',
	JiraPlansManageFeatures: 'jira-atlassian-plan-set-release-enabled',
	JiraPlansAddDependency: 'jira-atlassian-plan-add-work-item-dependencies',
	JiraPlansRemoveDependency: 'jira-atlassian-plan-remove-work-item-dependencies',
	// Capacity Planning
	ManageCapacityPlan: 'capacity-plan-update-single-action',
	// Atlassian Teams
	AtlassianTeamUpdateArchive: 'atlassian-team-atlassian-team-update-archive',
	// Focus Asks
	FocusCreateAsk: 'passionfruit-atlassian-workspace-create-asks',
	// Bitbucket
	BitbucketPullRequestComment: 'bitbucket-pull-request-comment',
	// Slack
	SlackSendChannelMessage: 'slack-send-channel-message',
	// Others
	StoreRecommendationCard: 'store-recommendation-card',
	RequireInformationTool: 'RequireInformationTool',
	HiringManagerTool: 'HiringManagerTool',
	JsmSuggestAndAddFieldsToRequestType: 'SuggestAndAddFieldsToRequestType',
	JsmAtlassianProjectCreateJsmRequestTypeWithFields:
		'jsm-atlassian-project-create-jsm-request-type-with-fields',
	// Google Docs
	GoogleDocCreate: 'google-doc-create',
	// Convo AI agent tools
	ExecutePython: 'execute_python',
	PlanComplete: 'plan_complete',
	AskQuestion: 'ask_question',
	JsmAtlassianProjectCreateJsmQueue: 'jsm-atlassian-project-create-jsm-queue',
	JsmAtlassianProjectCreateJsmQueueGroup: 'jsm-atlassian-project-create-jsm-queue-group',
	JsmAtlassianProjectUpdateJsmQueue: 'jsm-atlassian-project-update-jsm-queue',
	JsmAtlassianProjectUpdateJsmQueueGroup: 'jsm-atlassian-project-update-jsm-queue-group',
	JsmAtlassianProjectUpdateRequestTypePortalGroups:
		'jsm-atlassian-project-update-request-type-groups',
	JsmAtlassianRequestTypeUpdateWorkflow: 'jsm-atlassian-request-type-update-workflow',
	JsmSelectHardwareTypes: 'ham-onboarding-hardware-assets-types',
	JsmSelectHardwareTypesSkill: 'ham-onboarding-hardware-assets-types-skill',
	JsmCreateSlaPlugin: 'jsm-create-sla-plugin',
	JsmUpdateSlaPlugin: 'jsm-update-sla-plugin',
	// Confluence AIFC
	AifcAdfUpdate: 'aifc-adf-update',
	// Google Calendar
	GoogleCalendarEventCreate: 'google-calendar-event-create',
	// Add other keys here as needed
	ScheduledChat: 'ScheduleRovoChatTool',
	ImageSearch: 'image-search',
	MultipleChoiceQuestionsTool: 'MultipleChoiceQuestionsTool',
	AgenticPlanTool: 'AgenticPlanTool',
	CreateKBCard: 'jsm-atlassian-jsm-kb-bulk-create-draft-topics',
	CreateKbArticlesCard: 'jsm-atlassian-jsm-kb-validate-draft-articles',
	// Custom Skills
	CreateCustomSkillTool: 'CreateCustomSkillTool',
	UpdateCustomSkillTool: 'UpdateCustomSkillTool',
} as const;

export const FOCUS_CREATE_ASK_KEY: (typeof ActionKeys)['FocusCreateAsk'] =
	ActionKeys.FocusCreateAsk;
export const GOOGLE_DOC_CREATE_KEY: (typeof ActionKeys)['GoogleDocCreate'] =
	ActionKeys.GoogleDocCreate;

export const EXECUTE_PYTHON_KEY = 'execute_python';
export const PLAN_COMPLETE_KEY = 'plan_complete';
export const ASK_QUESTION_KEY = 'ask_question';
// Actions can declare this when their UI replaces or supersedes the footer (e.g. user-answer cards).
export const ACTIONS_HIDING_FOOTER_BUTTONS: ReadonlySet<string> = new Set([
	ASK_QUESTION_KEY,
	PLAN_COMPLETE_KEY,
]);

export const ActionPredicateKeys = {
	DynamicAction: 'dynamicAction',
	Resumption: 'resumption',
} as const;

export const ACTION_RENDER_KEYS = Object.values(ActionKeys) as readonly string[];

export const GENERIC_EXTERNAL_ACTION_ERROR_KEY = 'generic-external-action-error';
export const JIRA_FIND_ISSUES_KEY = 'jira-find-issues';
export const JIRA_SMART_ISSUE_CREATE_ALL_FIELDS_KEY =
	'jira-atlassian-work-item-create-all-field-types';
export const JSM_CREATE_REQUEST_KEY = 'jsm-create-request';
export const JSM_CREATE_REQUEST_V2_KEY = 'jsm-create-request-v2';
export const CREATE_REQUEST_KEY = 'create-request';
export const JSM_CREATE_EMBEDDED_REQUEST_KEY = 'help-form-submit';
export const JSM_LIVECHAT_KEY = 'jsm-livechat';
export const JIRA_ISSUE_TRANSITION_KEY = 'jira-issue-transition-bulk';
export const JIRA_EPICS_SUGGEST_KEY = 'jira-epics-suggest';
export const JIRA_ISSUE_DELETE_KEY = 'jira-issue-delete';
export const JIRA_ISSUE_MOVE_KEY = 'jira-issue-move';
export const JIRA_ISSUE_ASSIGN_KEY = 'jira-issue-assign-bulk';
export const JIRA_VERSION_CREATE_KEY = 'jira-version-create';
export const MANAGE_CAPACITY_PLAN_KEY = 'capacity-plan-update-single-action';
export const JIRA_WORKFLOW_EDITOR = 'jira-workflow-operations';

export const CONFLUENCE_PAGE_CREATE_KEY = 'confluence-page-create';
export const CONFLUENCE_PAGE_COMMENT_KEY = 'confluence-page-comment';
export const CONFLUENCE_PAGE_RENAME_KEY = 'confluence-page-rename';
export const CONFLUENCE_PAGE_ADD_LABEL_KEY = 'confluence-label-create';
export const CONFLUENCE_PAGE_MOVE_KEY = 'confluence-page-move';

export const DEEP_RESEARCH_CREATE_PAGE_ACTION_KEY = 'deep-research-report-confluence-export';

export const IMAGE_SEARCH_KEY = 'image-search';

export const REQUIRE_INFORMATION_TOOL = 'RequireInformationTool';
export const HIRING_MANAGER_TOOL_KEY = 'HiringManagerTool';

export const STUDIO_TRIGGER_SOLUTION_PLAN_KEY = 'studio-trigger-solution-plan';
export const STUDIO_ATLASSIAN_STUDIO_UPDATE_AGENT_DRAFT_KEY =
	'studio-atlassian-studio-update-agent-draft';
export const STUDIO_ATLASSIAN_WORKSPACE_UPDATE_DRAFT_AGENT_KEY =
	'studio-atlassian-workspace-update-draft-agent';

export const UPDATE_AGENT_CONFIGURATION_TOOL_KEY = 'UpdateAgentConfigurationTool';
export const JSM_JOURNEY_BUILDER_KEY = 'jsm-invoke-orchestrator-agent';
export const JSM_CREATE_SURVEY_KEY = 'jsm-atlassian-project-create-jsm-survey';
export const JSM_QUEUE_CREATE_KEY = 'jsm-atlassian-project-create-jsm-queue';
export const JSM_QUEUE_GROUP_CREATE_KEY = 'jsm-atlassian-project-create-jsm-queue-group';
export const JSM_QUEUE_UPDATE_KEY = 'jsm-atlassian-project-update-jsm-queue';
export const JSM_QUEUE_GROUP_UPDATE_KEY = 'jsm-atlassian-project-update-jsm-queue-group';
export const JSM_REQUEST_TYPE_PORTAL_GROUPS_UPDATE_KEY =
	'jsm-atlassian-project-update-request-type-groups';
export const JSM_REQUEST_TYPE_WORKFLOW_UPDATE_KEY = 'jsm-atlassian-request-type-update-workflow';
export const JSM_SLA_CREATE_KEY = 'jsm-create-sla-plugin';
export const JSM_SLA_UPDATE_KEY = 'jsm-update-sla-plugin';
export const JSM_REQUEST_TYPE_UPDATED_KEY =
	'jsm-atlassian-project-create-jsm-request-type-with-fields';
export const JSM_SUGGEST_AND_ADD_FIELDS_TO_REQUEST_TYPE_KEY = 'SuggestAndAddFieldsToRequestType';
export const JSM_CREATE_KB_TOPICS_KEY = 'jsm-atlassian-jsm-kb-bulk-create-draft-topics';
export const JSM_CREATE_KB_ARTICLES_KEY = 'jsm-atlassian-jsm-kb-validate-draft-articles';

export const STUDIO_AUTOMATION_TRIGGER_RULE_BUILD_KEY = 'studio-automation-trigger-rule-build';
export const STUDIO_AUTOMATION_CREATE_RULE_KEY =
	'automation-platform-atlassian-automation-create-rule';

/**
 * Key for the BE `CreateAgentTool` (see `CreateAgentToolDefinition.kt`).
 * Emitted as an output preview action carrying a `CreateAgentResult` payload.
 */
export const STUDIO_CREATE_AGENT_KEY = 'CreateAgentTool';

export const JIRA_PLANS_UPDATE_WORK_SOURCE_KEY = 'jira-atlassian-plan-update-work-sources';
export const JIRA_PLANS_ADD_PROGRAM_BOARD_KEY = 'jira-plan-add-program-board-plugin';
export const JIRA_PLANS_DELETE_PROGRAM_BOARD_KEY = 'Jira-Plan-Delete-Program-Board-Plugin';
export const JIRA_PLANS_CREATE_WORK_ITEM_KEY = 'jira-atlassian-plan-create-work-item';
export const JIRA_PLANS_MANAGE_FEATURES_KEY = 'jira-atlassian-plan-set-release-enabled';
export const JIRA_PLANS_ADD_DEPENDENCY_KEY = 'jira-atlassian-plan-add-work-item-dependencies';
export const JIRA_PLANS_REMOVE_DEPENDENCY_KEY = 'jira-atlassian-plan-remove-work-item-dependencies';
export const JIRA_PLANS_CREATE_RELEASE_KEY = 'Jira-Plan-Create-Release-Plugin';

export const STORE_RECOMMENDATION_ACTION_KEY = 'store-recommendation-card';
export const JIRA_HAM_AI_INSIGHTS_PREVIEW_KEY = 'jira-ham-ai-insights-preview';

export const ATLASSIAN_TEAM_UPDATE_ARCHIVE_KEY = 'atlassian-team-atlassian-team-update-archive';

export const SCHEDULED_CHAT_KEY = 'ScheduleRovoChatTool';

export const MULTIPLE_CHOICE_QUESTIONS_TOOL_KEY = 'MultipleChoiceQuestionsTool';

export const AGENTIC_PLAN_TOOL_KEY = 'AgenticPlanTool';

// used for testing only
export const customMessageActionKeys: string[] = [
	JIRA_FIND_ISSUES_KEY,
	JIRA_EPICS_SUGGEST_KEY,
	JIRA_ISSUE_DELETE_KEY,
	JIRA_ISSUE_MOVE_KEY,
];

export type ACTION_KEYS_WITH_CUSTOM_UI_TYPE =
	| (typeof ActionKeys)[keyof typeof ActionKeys]
	| typeof JIRA_VERSION_CREATE_KEY
	| typeof JSM_CREATE_REQUEST_KEY
	| typeof JSM_CREATE_EMBEDDED_REQUEST_KEY
	| typeof JIRA_ISSUE_TRANSITION_KEY
	| typeof JIRA_EPICS_SUGGEST_KEY
	| typeof JIRA_ISSUE_DELETE_KEY
	| typeof JIRA_ISSUE_MOVE_KEY
	| typeof JIRA_ISSUE_ASSIGN_KEY
	| typeof CONFLUENCE_PAGE_CREATE_KEY
	| typeof CONFLUENCE_PAGE_COMMENT_KEY
	| typeof JIRA_WORKFLOW_EDITOR
	| typeof DEEP_RESEARCH_CREATE_PAGE_ACTION_KEY
	| typeof REQUIRE_INFORMATION_TOOL
	| typeof GENERIC_EXTERNAL_ACTION_ERROR_KEY
	| typeof JSM_JOURNEY_BUILDER_KEY
	| typeof JSM_CREATE_SURVEY_KEY
	| typeof JIRA_PLANS_UPDATE_WORK_SOURCE_KEY
	| typeof STORE_RECOMMENDATION_ACTION_KEY
	| typeof SCHEDULED_CHAT_KEY
	| typeof FOCUS_CREATE_ASK_KEY
	| typeof MULTIPLE_CHOICE_QUESTIONS_TOOL_KEY
	| typeof AGENTIC_PLAN_TOOL_KEY;
